import { Typography, MenuItem, Paper, Stack, TextField } from '@mui/material';

const localizedFields = [
  {
    key: 'name',
    label: 'שם',
  },
  {
    key: 'shortName',
    label: 'שם קצר',
  },
  {
    key: 'branchName',
    label: 'שם סניף',
  },
  {
    key: 'city',
    label: 'עיר',
  },
  {
    key: 'country',
    label: 'מדינה',
  },
  {
    key: 'address',
    label: 'כתובת',
  },
];

const LanguageSection = ({ title, lang, placeForm, updateNested }) => (
  <Stack
    sx={{
      display: 'grid',
      gap: '12px',
      padding: '18px',
      border: '1px solid #f1cf86',
      borderRadius: '16px',
      background: '#fffbf2',
    }}
  >
    <Stack>
      <Typography>{title}</Typography>
    </Stack>
    <Stack
      sx={(theme) => ({
        display: 'grid',
        gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
        gap: '14px',
        [theme.breakpoints.down('sm')]: {
          gridTemplateColumns: '1fr',
        },
      })}
    >
      {localizedFields.map((field) => (
        <Stack key={field.key}>
          {field.label}
          <TextField
            value={placeForm[field.key][lang]}
            onChange={(event) => updateNested(field.key, lang, event.target.value)}
            fullWidth
          />
        </Stack>
      ))}
    </Stack>
  </Stack>
);

const GeneralTab = ({ placeForm, setPlaceForm, updateNested, behaviorTypes }) => (
  <Stack sx={{ width: "100%", gap: 2 }}>

    <Stack
      sx={{
        border: '1px solid var(--line)',
        borderRadius: '14px',
        padding: '16px',
        background: '#fff',
      }}
    >
      <Stack
        sx={{
          display: 'none',
          justifyContent: 'space-between',
          alignItems: 'end',
          gap: '12px',
          marginBottom: '14px',
        }}
      >
        <Typography>פרטים כלליים</Typography>
      </Stack>
      <Stack
        sx={(theme) => ({
          display: 'grid',
          gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
          gap: '14px',
          [theme.breakpoints.down('sm')]: {
            gridTemplateColumns: '1fr',
          },
        })}
      >
        <Stack>
          סטטוס
          <TextField
            value={placeForm.status}
            onChange={(e) =>
              setPlaceForm({
                ...placeForm,
                status: e.target.value,
              })
            }
            select
            fullWidth
          >
            <MenuItem value="active">active</MenuItem>
            <MenuItem value="pending">pending</MenuItem>
            <MenuItem value="rejected">rejected</MenuItem>
          </TextField>
        </Stack>
        <Stack>
          סוג התנהגות
          <TextField
            value={placeForm.behaviorType}
            onChange={(e) =>
              setPlaceForm({
                ...placeForm,
                behaviorType: e.target.value,
              })
            }
            select
            fullWidth
          >
            <MenuItem value="">בחר סוג התנהגות</MenuItem>
            {behaviorTypes.map((option) => (
              <MenuItem key={option.key || option.value} value={option.key || option.value}>
                {option.label}
              </MenuItem>
            ))}
          </TextField>
        </Stack>
        <Stack>
          מבנה המקום
          <TextField
            value={placeForm.placeKind}
            onChange={(e) =>
              setPlaceForm({
                ...placeForm,
                placeKind: e.target.value,
              })
            }
            select
            fullWidth
          >
            <MenuItem value="standalone">מקום עצמאי</MenuItem>
            <MenuItem value="container">מתחם / קניון</MenuItem>
            <MenuItem value="unit">מקום בתוך מתחם</MenuItem>
          </TextField>
        </Stack>
        {placeForm.placeKind === 'unit' && (
          <>
            <Stack>
              מקום מכיל
              <TextField
                disabled
                value={
                  placeForm.containment?.parentName || placeForm.containment?.parentPlaceId || ''
                }
                fullWidth
              />
            </Stack>
            <Stack>
              קומה
              <TextField
                value={placeForm.containment?.floor || ''}
                onChange={(e) =>
                  setPlaceForm((current) => ({
                    ...current,
                    containment: {
                      ...(current.containment || {}),
                      floor: e.target.value,
                    },
                  }))
                }
                select
                fullWidth
              >
                <MenuItem value="">בחירת קומה</MenuItem>
                {placeForm.availableFloors.map((floor) => (
                  <MenuItem key={floor} value={floor}>
                    {floor}
                  </MenuItem>
                ))}
              </TextField>
              {!placeForm.availableFloors.length && (
                <Typography>יש להגדיר תחילה קומות במתחם המכיל.</Typography>
              )}
            </Stack>
          </>
        )}
        <Stack>
          מקור
          <TextField
            value={placeForm.source}
            onChange={(e) =>
              setPlaceForm({
                ...placeForm,
                source: e.target.value,
              })
            }
            select
            fullWidth
          >
            <MenuItem value="system">system</MenuItem>
            <MenuItem value="user">user</MenuItem>
            <MenuItem value="admin">admin</MenuItem>
          </TextField>
        </Stack>
      </Stack>
    </Stack>

    <Stack
      sx={(theme) => ({
        display: 'grid',
        gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
        gap: '16px',
        [theme.breakpoints.down('md')]: {
          gridTemplateColumns: '1fr',
        },
      })}
    >
      <LanguageSection title="עברית" lang="he" placeForm={placeForm} updateNested={updateNested} />
      <LanguageSection title="אנגלית" lang="en" placeForm={placeForm} updateNested={updateNested} />
      <LanguageSection title="ספרדית" lang="es" placeForm={placeForm} updateNested={updateNested} />
    </Stack>
  </Stack>
);
export default GeneralTab;
